import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../../styles/Layout.css";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div className="layout">
      <Header />
      <main className="main-content"><Outlet /></main>
      <Footer />
    </div>
  );
};

export default Layout;
